import { Component, HostBinding, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { OverlayContainer } from "@angular/cdk/overlay";
import { fromEvent, Observable, Subscription } from "rxjs";
import { ThemeService } from "./providers/service/theme.service";
import { ParseApiService } from "./providers/service/parse-api.service";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "./providers/service/user.service";
import { ChartService } from "./providers/service/chart.service";
import { Router } from "@angular/router";
import { NotificationsService } from "./providers/service/notifications.service";
import { Title } from "@angular/platform-browser";
import { GlobalVariablesService, stringIsSet } from "./providers/service/global-variables.service";
import { environment } from "../environments/environment";
import { map } from "rxjs/operators";
import { DateAdapter } from "@angular/material/core";
import { Platform } from "@angular/cdk/platform";
import { UserPermissionsService } from "./providers/service/user-permissions.service";
import { InitializeGlobalVariableService } from './providers/service/initialize-global-variable.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {


    themingSubscription: Subscription;
    @HostBinding('class') public cssClass: string;
    public isConnectToProd = environment.forceProductionKey == true
    // @HostListener('window:wheel', ['$event'],{ passive: false })
    // onWindowScroll(event: WheelEvent) {
    //     if (event.ctrlKey || event.metaKey) {
    //         console.log('stop')
    //         event.preventDefault();
    //         event.stopImmediatePropagation();
    //     }
    // }

    favIcon: HTMLLinkElement | null = document.querySelector('#appIcon');
    subscriptions = new Subscription();

    changeIcon(directory: string = 'default_') {
    }

    isLogged
    public showSidenav$: Observable<boolean>

    constructor(
        private themingService: ThemeService,
        private overlayContainer: OverlayContainer,
        private translateService: TranslateService,
        private userService: UserService,
        private chartService: ChartService,
        private router: Router,
        private globalVariablesService: GlobalVariablesService,
        private initializeGlobalVariableService: InitializeGlobalVariableService,
        title: Title,
        private dateAdapter: DateAdapter<Date>,
        renderer: Renderer2,
        platform: Platform
    ) {
        
        const style = renderer.createElement('style');
        style.type = 'text/css';
        let css
        const isIphone = platform.IOS && (navigator && navigator.userAgent && /iPhone/i.test(navigator.userAgent));
        if (!isIphone) {
            css = '.height100vh {height: 100vh;}';
        } else {
            css = '.height100vh {height:' + window.innerHeight + 'px;}';
            this.subscriptions.add(
                fromEvent(window, 'resize').subscribe(() => {
                    css = '.height100vh {height:' + window.innerHeight + 'px;}';
                    renderer.setProperty(style, 'textContent', css)
                })
            )
        }

        renderer.appendChild(style, renderer.createText(css))
        renderer.appendChild(document.head, style);

        const pathOrigin = window.location.origin;
        if (pathOrigin.includes('e-wawe')) {
            this.favIcon!.href = 'assets/icon/dynamicIconByUrl/e_wave/favicon.svg';
            this.globalVariablesService.defaultLogoPc = 'assets/icon/dynamicIconByUrl/e_wave/logo.svg';
            this.globalVariablesService.defaultLogoApp = 'assets/icon/dynamicIconByUrl/e_wave/logo.svg';
            this.globalVariablesService.logoAppUrl = 'assets/icon/dynamicIconByUrl/e_wave/logo.svg';
            this.globalVariablesService.logoPcUrl = 'assets/icon/dynamicIconByUrl/e_wave/logo.svg';
            title.setTitle('Energy monitoring')
        } else if (pathOrigin.includes('iam')) {
            this.favIcon!.href = 'assets/icon/dynamicIconByUrl/iam_/favicon.svg';
            this.globalVariablesService.defaultLogoPc = 'assets/icon/dynamicIconByUrl/iam_/logo.png';
            this.globalVariablesService.defaultLogoApp = 'assets/icon/dynamicIconByUrl/iam_/logo.png';
            this.globalVariablesService.logoAppUrl = 'assets/icon/dynamicIconByUrl/iam_/logo.png';
            this.globalVariablesService.logoPcUrl = 'assets/icon/dynamicIconByUrl/iam_/logo.png';
            title.setTitle('Energy monitoring')
        } else if (pathOrigin.includes('idea75')) {
            this.favIcon!.href = 'assets/icon/dynamicIconByUrl/idea_75/favicon.svg';
            this.globalVariablesService.defaultLogoPc = 'assets/icon/dynamicIconByUrl/idea_75/logo.svg';
            this.globalVariablesService.defaultLogoApp = 'assets/icon/dynamicIconByUrl/idea_75/logo.svg';
            this.globalVariablesService.logoAppUrl = 'assets/icon/dynamicIconByUrl/idea_75/logo.svg';
            this.globalVariablesService.logoPcUrl = 'assets/icon/dynamicIconByUrl/idea_75/logo.svg';
            title.setTitle('Energy monitoring')
        } else {
            this.favIcon!.href = 'assets/icon/dynamicIconByUrl/default_/favicon.svg';
            this.globalVariablesService.defaultLogoPc = 'assets/icon/dynamicIconByUrl/default_/logo.svg';
            this.globalVariablesService.defaultLogoApp = 'assets/icon/dynamicIconByUrl/default_/logo.svg';
            this.globalVariablesService.logoAppUrl = 'assets/icon/dynamicIconByUrl/default_/logo.svg';
            this.globalVariablesService.logoPcUrl = 'assets/icon/dynamicIconByUrl/default_/logo.svg';
            title.setTitle('Energy monitoring - huna')
        }
        //first commit mac
        translateService.addLangs(['it', 'en', 'es', 'ca', 'fr']);
        translateService.setDefaultLang('it');
        this.dateAdapter.setLocale(this.translateService.currentLang)

        this.subscriptions.add(
            this.translateService.onLangChange.subscribe(lang => {
                this.dateAdapter.setLocale(this.translateService.currentLang)
            })
        )
        const selectedLang = this.globalVariablesService.selectedLang
        if (stringIsSet(selectedLang) && this.translateService.getLangs().includes(selectedLang)) {
            translateService.use(selectedLang)
        } else {
            translateService.use(translateService?.getBrowserLang()!);
        }

        this.cssClass = '';
        this.themingSubscription = this.themingService.theme.subscribe((theme: string) => {
            this.cssClass = theme;
            this.applyThemeOnOverlays();
            this.chartService.updateWithChangeTheme(theme);
        });
        if (!window.location.href.includes('anonymous-action')) {
            this.isLogged = () => this.userService.isLogged()
        } else {
            this.isLogged = () => false
        }
        this.showSidenav$ = this.globalVariablesService.notShowSidenav$.pipe(
            map(notShow => {
                return !(notShow == true)
            })
        )


    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.themingSubscription.unsubscribe();
        this.subscriptions.unsubscribe()
        this.initializeGlobalVariableService.destroyGlobalVariable();
    }


    get currentUrl() {
        return this.router.url
    }

    private applyThemeOnOverlays() {
        // remove old theme class and add new theme class
        // we're removing any css class that contains '-theme' string but your theme classes can follow any pattern
        const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
        const themeClassesToRemove = Array.from(this.themingService.themes);
        if (themeClassesToRemove.length) {
            overlayContainerClasses.remove(...themeClassesToRemove);
        }
        overlayContainerClasses.add(this.cssClass);
    }


}
